module.exports = __webpack_public_path__ + "static/media/tooltip_icon_small.cc53bb45.svg";